import { useEffect } from 'react';

const useCloseOnEscape = (onClose: () => void, show: boolean) => {
    useEffect(() => {
        if (!show) {
            return;
        }

        const onKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                onClose?.();
            }
        };

        document.addEventListener('keydown', onKeyDown);

        return () => document.removeEventListener('keydown', onKeyDown);
    }, [show, onClose]);
};

export default useCloseOnEscape;
